// Names from https://colornamer.robertcooper.me

export const colours = {
  white: "#ffffff",
  black: "#000000",
  darkToneInk: "#121212",
  superSilver: "#eeeeee",
  gallery: "#ececec",
  spanishGrey: "#d8d8d8",
  whiteSolid: "#f2f5fa",
  sparklingSnow: "#e6f8f6",
  agedGray: "#7d7f80",
  charcoalDust: "#595858",
  crowberryBlue: "#053747",
  swimmersPool: "#22c3bb",
  porpoisePlace: "#0c687d",
  pacificBlue: "#059dc1",
  indianRed: "#e94f5f",
  redRampage: "#ef3826",
  spicedPurple: "#b90a67",
  flourescentOrange: "#ffce00",
  // low, medium, high risk colours.
  arcadianGreen: "#9dca8d",
  californiaDreaming: "#dcc769",
  deepCoral: "#db7b59",
  poisonIvy: "#00ac43",
  friendlyFrost: "#bbfbfb",
  // unknown, low, high risk colours
  aquaSphere: "#9bafb5",
  limeRasp: "#afcb08",
  desire: "#e83c4e",
  grey: {
    5: "#f4f4f4",
    10: "#eeeeee",
    20: "#dedede",
    30: "#cdcdcd",
    40: "#d9d9d9",
    50: "#bdbdbc",
    60: "#9b9b9b",
    70: "#8b8b8a",
    80: "#7a7a79",
    90: "#6a6a69",
    100: "#595958",
  },
}
